import housingTypesList from "./housing-types.list";

export const HousingTypeStores = {
    list: housingTypesList
};